import React, { useState, useEffect, useContext } from "react";
import axios from "../../../../axios/index";

import { UserContext } from "../../../Context/UserContextProvider";
import { useHistory } from "react-router-dom";

// components
import HomeNavbar from "../../../Home/HomeNavbar/HomeNavbar";
import { ToastContainer, toast } from "react-toastify";
import UserSideDashboard from "../../UserSideDashboard/UserSideDashboard";
import Footer from "../../../Home/Footer/Footer";
import AddNewFileDropdown from "../../../Dashboard/DashboardReuseAbleComponents/AddNewFiles/AddNewFileDropdown";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { removeCommas } from "@persian-tools/persian-tools";
import { addRequestValidate } from "./addRequestValidate";
import PlacesInput from "../../../Dashboard/DashboardReuseAbleComponents/AddNewFiles/PlacesInput";

// styles
import styles from "./AddRequest.module.css";
import Dstyles from "../../UserMyAds/UserMyAds.module.css";
import inputStyles from "../../../Dashboard/DashboardReuseAbleComponents/AddNewFile.module.css";
import loaderStyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";
import "react-toastify/dist/ReactToastify.css";

export default function AddRequest() {
  const { userToken } = useContext(UserContext);
  const history = useHistory();
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const [value, setValue] = useState("271");
  const [place, setPlace] = useState([]);
  const [fileData, setFileData] = useState({
    title: "",
    meter: "",
    startPrice: "",
    endPrice: "",
    facilities: "",
    description: "",
    city: "",
    place: "",
    year: "",
    room: "",
    floor: "",
    showList: false,
  });
  const [facilities, setFacilities] = useState([
    { id: "1", name: "آسانسور", status: false },
    { id: "2", name: "پارکینگ", status: true },
    { id: "3", name: "انباری", status: false },
    { id: "4", name: "بالکن", status: false },
  ]);

  const addCommas = num => num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const removeNonNumeric = num => num?.toString().replace(/[^0-9]/g, "");

  function changeHandler(event) {
    if (event.target.name === "slug") {
      let value = event.target.value;
      value = value.replace(/[^A-Za-z-0-9]/gi, " ");
      setFileData(prev => {
        return { ...prev, slug: value };
      });
    } else {
      setFileData(prev => {
        return { ...prev, [event.target.name]: event.target.value };
      });
    }
  }

  function priceHandler(event) {
    setFileData(prev => {
      return { ...prev, [event.target.name]: removeCommas(event.target.value) };
    });
  }

  const handleChange = event => {
    setValue(event.target.value);
  };

  const removeSymbolNumberHandler = e => {
    const removeSymbolNumber = ["e", "E", ".", "-"];

    if (removeSymbolNumber.includes(e.key)) {
      e.preventDefault();
    }
  };

  function statusHandler(id) {
    const itemSelected = facilities.find(item => id === item.id);
    const newState = facilities.map(obj => {
      if (obj.id === id) {
        return { ...obj, status: !itemSelected.status };
      }
      return obj;
    });
    // console.log(newState)
    setFacilities(newState);
  }

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)
      const apiData = await axios.get("Category/GetParentCategories", {
        headers: { authorization: "Bearer " + userToken },
      });
      setCategories(apiData.data.data);
      setIsLoading(false);
    };
    dataHandler();
  }, [userToken]);

  useEffect(() => {
    setErrors(addRequestValidate(fileData, value, facilities, place));
  }, [fileData, value, facilities, place]);

  return (
    <>
      {isLoading ? (
        <div className={loaderStyles.loader_container}>
          <div className={loaderStyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
          <ToastContainer
            position="top-right"
            autoClose={8000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="light"
          />
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar />
            <div className="container py-3 px-0 mt-4">
              <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
                <UserSideDashboard myReqs />
                <div className={`d-flex flex-column align-items-center justify-content-start p-4 ${Dstyles.main_container}`}>
                  <Title />
                  <SelectCategory value={value} handleChange={handleChange} categories={categories} />
                  <div className="w-100 d-flex flex-column flex-wrap justify-content-center align-items-center mb-4">
                    {/* title */}
                    <div className="w-100 d-flex align-items-start justify-content-center flex-column mb-4">
                      <div className={`mb-3 ${inputStyles.input_header}`}>عنوان درخواست</div>
                      <input
                        type="text"
                        name="title"
                        value={fileData.title}
                        onChange={changeHandler}
                        className={`w-100 bg-light py-2 pe-3 ${inputStyles.input}`}
                        placeholder="مثلا آپارتمان ۳۰۰ متر تختی"
                      />
                    </div>
                    {/* title */}

                    {/* submenu row1 */}
                    <div className="w-100 d-flex align-items-center justify-content-between flex-wrap my-2">
                      <AddNewFileDropdown setDropDownsData={setFileData} yearName={fileData.year} year userAdd userRequest />
                      <PlacesInput
                        placeName={place}
                        setDropDownsData={setFileData}
                        userAdd
                        userRequest
                        statusHandler={checkboxHandler}
                        showLists={fileData.showList}
                      />
                      <AddNewFileDropdown setDropDownsData={setFileData} cityName={fileData.city} city userAdd />
                    </div>
                    {/* submenu row1 */}

                    {/* submenu row2 */}
                    <div className="w-100 d-flex align-items-center justify-content-between flex-wrap my-2" style={{ minHeight: "102px" }}>
                      <div className="d-flex flex-column justify-content-end align-items-start">
                        <div className={`mb-2 ${inputStyles.input_header}`}>متراژ حداقل</div>
                        <label className="position-relative" htmlFor="meter">
                          <span className={inputStyles.input_left_text}>متر</span>
                          <input
                            type="number"
                            name="meter"
                            value={fileData.meter}
                            onChange={changeHandler}
                            className={`bg-light py-2 ps-5 pe-2 ${inputStyles.input_meter_user}`}
                            style={{ textAlign: "right" }}
                            onKeyDown={removeSymbolNumberHandler}
                          />
                        </label>
                      </div>
                      <AddNewFileDropdown setDropDownsData={setFileData} floorNumber={fileData.floor} floor userAdd userRequest />
                      <AddNewFileDropdown setDropDownsData={setFileData} roomNumber={fileData.room} room userAdd userRequest />
                    </div>
                    {/* submenu row2 */}

                    {/* start & end prices*/}
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start flex-wrap mt-4">
                      <div className={`mb-3 ${inputStyles.title_bold}`}>قیمت ملک</div>
                      <div className="d-flex align-items-center justify-content-center flex-wrap">
                        <div className="d-flex flex-column justify-content-center align-items-start ms-md-2 mb-md-0 mb-3">
                          <div className={`mb-3 ${inputStyles.input_header}`}>از</div>
                          <label className="position-relative" htmlFor="startPrice">
                            <span className={inputStyles.input_left_text}>تومان</span>
                            <input
                              type="text"
                              name="startPrice"
                              value={addCommas(removeNonNumeric(fileData.startPrice))}
                              onChange={priceHandler}
                              className={`bg-light py-2 ps-5 pe-2 ${inputStyles.input_meter_user}`}
                              style={{ textAlign: "right" }}
                              onKeyDown={removeSymbolNumberHandler}
                            />
                          </label>
                        </div>

                        <div className="d-flex flex-column justify-content-center align-items-start ms-md-2 mb-md-0 mb-3">
                          <div className={`mb-3 ${inputStyles.input_header}`}>تا</div>
                          <label className="position-relative" htmlFor="endPrice">
                            <span className={inputStyles.input_left_text}>تومان</span>
                            <input
                              type="text"
                              name="endPrice"
                              value={addCommas(removeNonNumeric(fileData.endPrice))}
                              onChange={priceHandler}
                              className={`bg-light py-2 ps-5 pe-2 ${inputStyles.input_meter_user}`}
                              style={{ textAlign: "right" }}
                              onKeyDown={removeSymbolNumberHandler}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* start & end prices*/}

                    {/* Checkbox */}
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start flex-wrap mt-5 my-4">
                      <div className={`mb-3 ${inputStyles.title_bold}`}>امکانات درخواستی</div>
                      <div className="w-100 d-flex align-items-center justify-content-between flex-wrap">
                        {facilities?.map(item => (
                          <div key={item.id} className="d-flex align-items-center justify-content-center mx-3 mx-md-0">
                            <Checkbox
                              checked={item.status}
                              onClick={() => statusHandler(item.id)}
                              inputProps={{ "aria-label": "controlled" }}
                              size="medium"
                              name="heldOn"
                            />
                            <div className={inputStyles.input_header}>{item.name}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Checkbox */}

                    {/* description */}
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start my-4">
                      <div className={`mb-3 ${inputStyles.input_header}`}>توضیحات</div>
                      <textarea
                        id="menuone"
                        type="text"
                        name="description"
                        className={`w-100 px-3 pt-3 ${inputStyles.textarea}`}
                        placeholder="توضیحات خود را وارد کنید"
                        onChange={changeHandler}
                        value={fileData.description}></textarea>
                    </div>
                    {/* description */}

                    {/* bottom Btn */}
                    <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center flex-wrap my-2">
                      {btnLoader ? (
                        <div className={inputStyles.btn_loader_container}>
                          <div className={inputStyles.btn_spinner}></div>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center my-md-0 my-2">
                          <button className={inputStyles.filled_btn} type="" onClick={submitHandler}>
                            درخواست
                          </button>
                        </div>
                      )}
                    </div>
                    {/* bottom Btn */}
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  function checkboxHandler(item) {
    const found = place.find(pItem => pItem === item);
    // console.log(found)
    if (!found) {
      setPlace(current => [...current, item]);
      setFileData(prev => {
        return { ...prev, showList: false };
      });
    } else {
      setPlace(current =>
        current.filter(element => {
          return element !== item;
        })
      );
      setFileData(prev => {
        return { ...prev, showList: false };
      });
    }
  }

  function submitHandler() {
    if (!Object.keys(errors).length) {
      notify("درحال ارسال درخواست شما", "success");
    } else {
      notify("!لطفا تمام فیلد هارا پرکنید", "error");
    }
  }

  function notify(text, type) {
    if (type === "success") {
      setBtnLoader(true);
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      postHandler();
      setBtnLoader(false);
    } else if (type === "posted") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    } else if (type === "posted-error") {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    } else {
      setBtnLoader(true);
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function postHandler() {
    const p2e = s => s.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    const year = p2e(fileData.year);
    setBtnLoader(true);
    try {
      var data = new FormData();
      data.append("Floor", fileData.floor === "فرقی ندارد" ? "0" : p2e(fileData.floor));
      data.append("City", p2e(fileData.city));
      data.append("Title", fileData.title);
      data.append("Meterage", p2e(fileData.meter));
      data.append("RoomCount", fileData.room === "فرقی ندارد" ? "0" : p2e(fileData.room));
      data.append("CategoryId", value);
      data.append("EntPrice", fileData.endPrice);
      data.append("StartPrice", fileData.startPrice);
      data.append("ConstructionYear", year === "کمتر از 5 سال" ? 1 : year === "بیشتر از 5 سال" ? 2 : year === "فرقی نمیکند" && 3);
      data.append("Description", fileData.description);

      for (const placeItem of place) {
        data.append("AreaKeys", placeItem);
      }

      for (const placeItem of place) {
        data.append("AreaValues", placeItem);
      }

      for (const facility of facilities.filter(item => item.status === true)) {
        data.append("Keys", facility.id);
      }

      for (const facility of facilities.filter(item => item.status === true)) {
        data.append("Values", facility.name);
      }

      const apiData = await axios.post("RequestFile", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(apiData)
      setBtnLoader(false);
      notify("درخواست با موفقیت فرستاده شد", "posted");
      history.push("/user-request-file");
    } catch (error) {
      notify("خطایی رخ داد", "posted-error");
      history.push("/user-request-file");
    }
  }
}

export function Title() {
  return (
    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mb-5">
      <div className={`my-md-0 my-2 ${Dstyles.title}`}>درخواست جدید</div>
    </div>
  );
}

export function SelectCategory({ value, handleChange, categories, managment }) {
  return (
    <div className="w-100 d-flex flex-column align-items-start justify-content-center">
      <h5 className={styles.text_gray}>نوع ملک درخواستی را انتخاب کنید</h5>

      <div className={`w-100 d-flex ${managment ? "justify-content-start" : "justify-content-between"}  align-items-center flex-wrap my-3`}>
        {categories?.map(item => (
          <RadioGroup
            key={item.id}
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            className="d-flex justify-content-md-between justify-content-evenly align-items-center flex-wrap flex-row"
            value={value}
            onChange={handleChange}>
            <FormControlLabel className="me-0 ms-md-5 ms-0" value={item.id} control={<Radio />} label={item.title} />
          </RadioGroup>
        ))}
        {/* </FormControl> */}
      </div>
    </div>
  );
}
